export const statusNegativacaoList = [
    {value: 'EM_NEGATIVACAO', label: "Em negativação"},
    {value: 'NEGATIVADO', label: "Negativado"},
    {value: 'NEGATIVACAO_CANCELADA', label: "Negativação cancelada"},
    {value: 'REJEITADO', label: "Rejeitado"},
    {value: 'NAO_EXECUTADA', label: "Não executada"},
]